<template>
    <v-snackbar v-model="visible" :timeout="timeout" :color="color" :top="top" :bottom="bottom">
        <slot>{{ message }}</slot>
        <template v-if="closable" v-slot:action="{ attrs }">
            <v-btn color="white" icon v-bind="attrs" @click="hide"><v-icon>close</v-icon></v-btn>
        </template>
    </v-snackbar>
</template>
<script>
export default {
    name: "ErrorSnackBar",
    props: {
        value: {},
        timeout: { default: 5000 },
        color: { default: 'error' },
        closable: { type: Boolean, default: true },
        top: {},
        bottom: {},
    },
    data() {
        return {
            visible: !!this.value,
        };
    },
    methods: {
        hide() {
            this.visible = false;
        }
    },
    computed: {
        message() {
            return (this.value && this.value.response && this.value.response.data && this.value.response.data.message)
                || this.value;
        },
        errors() { return this.value && this.value.response && this.value.response.data && this.value.response.data.errors; },
    },
    watch: {
        value() {
            this.visible = !!this.value;
        }
    }
}
</script>
